/** Custom order alert — public/sounds/order-alert.mp3 */
export const ORDER_ALERT_SOUND_URL = '/sounds/order-alert.mp3'

const DEDUPE_MS = 2500
let audio: HTMLAudioElement | null = null
let listenerAttached = false
let lastPlayedAt = 0

/** Play custom alert only (notifications are shown silent to avoid OS default sound). */
export function playOrderAlertSound(): void {
  if (typeof window === 'undefined') return
  const now = Date.now()
  if (now - lastPlayedAt < DEDUPE_MS) return
  lastPlayedAt = now

  try {
    if (!audio) {
      audio = new Audio(ORDER_ALERT_SOUND_URL)
      audio.volume = 0.9
    }
    audio.currentTime = 0
    void audio.play().catch(() => {})
  } catch {
    /* ignore */
  }
}

export function setupOrderAlertSoundListener(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  if (listenerAttached) return
  listenerAttached = true

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'PLAY_ORDER_ALERT_SOUND') {
      playOrderAlertSound()
    }
  })
}

/** Visual-only notification — custom sound is played separately. */
export function orderNotificationOptions(): NotificationOptions {
  return { silent: true }
}
